
import React from 'react';
import { Link } from 'react-router-dom';
import { Progress, Tooltip } from 'antd';

import arrow from "../../../../assets/svg/arrow-right.svg"


export default (props) =>{

    return (
        <div className="transfer-cost-report">
            <ul>
                <li>{props.source}</li>
                <li>{props.totalTransfer}</li>
                <li>{props.totalCost}</li>
                <li>
                    <a onClick={props.onRowClick}>
                        <Tooltip title="Detail">
                            <img
                                className="arrow-icon"
                                src={arrow}
                                alt=""
                                

                                // onClick={e => {
                                // e.stopPropagation()
                                // history.push(`/addProvider`)
                                // }}
                            />
                        </Tooltip>
                    </a>
                </li>
            </ul>
        </div>
    )
}

